module.exports = __webpack_public_path__ + "img/canbadge-round-32mm-momo_trimmark.186dac42.png";